import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";

import { Consumer } from "../../shared/models/request/consumer";
import { Credentials } from "../../shared/models/request/credentials";
import { RequestHeader } from "../../shared/models/request/request-header";
import { APP_CONFIG } from "../services/app-config.service";
import { UtilityService } from "../../shared/services/utility.service";
import { Constants } from "../../shared/constants/constants";
import { SessionService } from "../services/session.service";
import { UserService } from "../services/user.service";

@Injectable()
export class AppInterceptor implements HttpInterceptor {

    transactionId = '';

    constructor(
        private userService: UserService,
        private utilities: UtilityService,
        private sessionService: SessionService,
        public router: Router
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url !== Constants.IPADDRESS_URL) {
            req = this.getUpdatedRequest(req);
        }
        return next.handle(req)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error?.error?.httpCode === Constants.UNAUTHORIZED_CODE &&
                        error?.error?.httpMessage === Constants.INVALID_JWT_MSG) {
                        this.userService.logoutUser();
                        this.router.navigate(['login']);
                    }
                    return throwError(() => error);
                })
            );
    }

    getUpdatedRequest(req: HttpRequest<any>): HttpRequest<any> {
        this.transactionId = req?.body?.transactionId || this.utilities.getTransactionID();
        if ((req.url).includes(APP_CONFIG.SEARCH_PLAN_MEMBERS_EP) ||
            (req.url).includes(APP_CONFIG.SEARCH_CONTACT_POINTS_EP) ||
            (req.url).includes(APP_CONFIG.BROKER_REPORT) ||
            (req.url).includes(APP_CONFIG.CREATE_PLAN_MEMBER_EP) ||
            (req.url).includes(APP_CONFIG.PROVIDER_REPORT) ||
            (req.url).includes(APP_CONFIG.PROVIDER_ACCOUNT_STATUS) ||
            (req.url).includes(APP_CONFIG.LOCKED_TAX_ID) ||
            (req.url).includes(APP_CONFIG.PROVIDERS_PIN_COUNT) ||
            (req.url).includes(APP_CONFIG.DELETE_TIN_OR_SSN) ||
            (req.url).includes(APP_CONFIG.UPDATE_PROVIDER_DISPLAY_NAME)) {
            req = req.clone({
                body: {
                    requestBody: req['body']
                },
                headers: this.getHttpHeaders(req.url)
            });
        }
        else if ((req.url).includes(APP_CONFIG.PROVIDER_TYPE_LIST) ||
            (req.url).includes(APP_CONFIG.SEARCH_PROVIDER_RECORD) ||
            (req.url).includes(APP_CONFIG.IFP_DATA_VALIDATE_URL) ||
            (req.url).includes(APP_CONFIG.IFP_DATA_UPLOAD_URL) ||
            (req.url).includes(APP_CONFIG.SUBSIDY_IFP_DATA_UPLOAD_URL) ||
            (req.url).includes(APP_CONFIG.SUBSIDY_IFP_DATA_VALIDATE_URL) ||
            (req.url).includes(APP_CONFIG.GET_PROFILE_PROVIDER)) {
            req = req.clone({
                headers: this.getHttpHeaders(req.url)
            });
        }
        else if ((req.url).includes(APP_CONFIG.PAYMENT_REPORT_LIST)) {
            req = req.clone({
                body: {
                    documentSearchRequest: {
                        requestHeader: this.getRequestHeader(req.url),
                        request: req['body']
                    }
                },
                headers: this.getHttpHeaders(req.url)
            });
        } else if ((req.url).includes(APP_CONFIG.PAYMENT_REPORT_DOWNLOAD)) {
            req = req.clone({
                body: {
                    documentRequest: {
                        requestHeader: this.getRequestHeader(req.url),
                        request: req['body']
                    }
                },
                headers: this.getHttpHeaders(req.url)
            });
        } else if ((req.url).includes(APP_CONFIG.ELIGIBILITY_INFO_EP)) {
            req = req.clone({
                body: {
                    memberDemographicRequest: {
                        requestHeader: this.getRequestHeader(req.url),
                        requestBody: req['body']
                    }
                },
                headers: this.getHttpHeaders(req.url)
            });
        } else if ((req.url).includes(APP_CONFIG.MEMBER_BILLING_INFO_EP)) {
            req = req.clone({
                body: {
                    getBillingInfoRequest: {
                        requestHeader: this.getRequestHeader(req.url),
                        requestBody: req['body']
                    }
                },
                headers: this.getHttpHeaders(req.url)
            });
        }
        else if ((req.url).includes(APP_CONFIG.GET_PIN_DETAILS)) {
            req = req.clone({
                body: {
                    requestHeader: this.getRequestHeader(req.url),
                    userAuthorizationData: {
                        idToken: 'pass_through',
                        idTokenType: 'jwt',
                    },
                    requestBody: req['body'],
                    paginationCriteria: {
                        "noOfRecords": "",
                        "pageNumber": ""
                    },
                    sortCriteria: {
                        "order": "desc",
                        "sortColumn": "providerTaxIdentifier"
                    }
                },
                headers: this.getHttpHeaders(req.url)
            });
        }
        else if ((req.url).includes(APP_CONFIG.PROFILE_EMAIL_ACTIVATION)) {
            req = req.clone({
                body: {
                    requestBody: req['body']
                },
                headers: this.getHttpHeaders(req.url)
            });
        }

        else {
            req = req.clone({
                body: {
                    requestHeader: this.getRequestHeader(req.url),
                    requestBody: req['body']
                },
                headers: this.getHttpHeaders(req.url)
            });
        }
        return req;
    }

    getRequestHeader(url: string) {
        let credentials: Credentials;
        if (url.includes(APP_CONFIG.MEMBER_INFO)) {
            credentials = new Credentials('string', APP_CONFIG.PASSTHROUGH, APP_CONFIG.AIP_SERVICES_MEMBERLOOKUP_TOKEN, 'plain_token');
        } else if (url.includes(APP_CONFIG.MANAGE_SEARCH_CSA_USER) ||
            url.includes(APP_CONFIG.MANAGE_CREATE_CSA_USER) ||
            url.includes(APP_CONFIG.MANAGE_MODIFY_CSA_USER) ||
            url.includes(APP_CONFIG.ADD_DNC_EP) ||
            url.includes(APP_CONFIG.GET_MANAGE_OEP)) {
            credentials = new Credentials('', '', '', '');
        } else if (url.includes(APP_CONFIG.EMPLOYER_SEARCH_ACCOUNT) ||
            url.includes(APP_CONFIG.LOAD_PROFILE) ||
            url.includes(APP_CONFIG.MODIFY_USER)) {
            credentials = new Credentials('', '', APP_CONFIG.PASSTHROUGH, 'id_token');
        } else if (url.includes(APP_CONFIG.BROKER_PROFILE_SUBMIT)) {
            credentials = new Credentials('', '', APP_CONFIG.PASSTHROUGH, 'id_token');
        } else if (url.includes(APP_CONFIG.ELIGIBILITY_INFO_EP)) {
            credentials = new Credentials('', '', APP_CONFIG.AIP_SERVICES_MEMBERDEMOGRAPHIC_TOKEN, 'plain_token');
        } else if (url.includes(APP_CONFIG.MEMBER_BILLING_INFO_EP)) {
            credentials = new Credentials('', '', APP_CONFIG.AIP_BILLINGINFO_TOKEN, '');
        } else if (url.includes(APP_CONFIG.MEMBER_SEARCH_HICN_MBI_LOOKUP)) {
            credentials = new Credentials('', '', APP_CONFIG.HICN_MBI_TOKEN, APP_CONFIG.TOKEN_TYPE);
        } else {
            credentials = new Credentials('', '', this.userService.getJwtToken, APP_CONFIG.TOKEN_TYPE);
        }

        let businessTransactionType;
        if (url.includes(APP_CONFIG.EMPLOYER_RESEND_VERIFICATION) || url.includes(APP_CONFIG.EMPLOYER_RESEND_ACTIVATION)) {
            businessTransactionType = 'csadmin';
        }
        else {
            businessTransactionType = 'dpadmin';
        }

        const consumer = new Consumer(
            Constants.APP_NAME, Constants.APP_NAME,
            Constants.DIGITAL, Constants.WEB_PORTAL,
            Constants.API_VERSION,
            new Date(new Date().getTime() + 4 * 60 * 60 * 1000).toLocaleTimeString(),
            APP_CONFIG.DOMAIN, businessTransactionType, '', '', ''
        );
        return (new RequestHeader(credentials, consumer, this.transactionId));
    }

    getHttpHeaders(url: string) {
        const dpAdminCall = this.userService.getJwtToken ? Constants.DPADMIN : '';
        if (url.includes(APP_CONFIG.BROKER_REPORT)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'Accept': 'application/csv',
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.BROKER_REPORT_CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.BROKER_REPORT_CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'ipAddress': this.userService.getIpAddress,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.SPLUNK_URL)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'hostName': APP_CONFIG.ENV_NAME,
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || Constants.UNAUTHUSER,
                'loggedInUserName': this.userService.getUserName || Constants.UNAUTHUSER,
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.CREATE_PLAN_MEMBER_EP)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sub': this.userService.getUserIdentifier,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.PROFILE_PROVIDER_SUBMIT)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'Accept': 'application/json',
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'csAdminId': this.userService.getUserIdentifier,
                'isCSAdminApplication': 'true',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'ipAddress': this.userService.getIpAddress,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.ADD_DNC_EP)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'dpauserid': this.userService.getUserIdentifier,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.TINS_NOT_REGISTERED)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'csAdminId': this.userService.getUserIdentifier,
                'ipAddress': this.userService.getIpAddress,
                'iscsadminapplication': 'true',
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        } else if (url.includes(APP_CONFIG.UPDATE_MANAGE_OEP)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'Accept': 'application/json',
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'csAdminId': this.userService.getUserIdentifier,
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'ipAddress': this.userService.getIpAddress,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        }
        else if (url.includes(APP_CONFIG.IFP_DATA_AUDIT_URL) ||
            url.includes(APP_CONFIG.IFP_DATA_DOWNLOAD_URL)) {
            return new HttpHeaders({
                'Content-Type': url.includes(APP_CONFIG.IFP_DATA_DOWNLOAD_URL) ? 'application/octet-stream' : 'application/json',
                'operationType': (url.includes(APP_CONFIG.IFP_DATA_DOWNLOAD_URL) ? "download" : "AUDIT"),
                'transactionId': this.transactionId,
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.BROKER_REPORT_CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.BROKER_REPORT_CLIENT_SECRET || '',
                'year': this.sessionService.getItem('downloadingYear') || '',
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        }
        else if (url.includes(APP_CONFIG.IFP_DATA_VALIDATE_URL) || url.includes(APP_CONFIG.IFP_DATA_UPLOAD_URL)) {
            return new HttpHeaders({
                'operationType': (url.includes(APP_CONFIG.IFP_DATA_UPLOAD_URL) ? 'UPLOAD' : "VALIDATE"),
                'transactionId': this.transactionId,
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.BROKER_REPORT_CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.BROKER_REPORT_CLIENT_SECRET || '',
                'userid': this.userService.getUserName,
                'token': this.userService.getJwtToken
            });
        } else if (url.includes(APP_CONFIG.SUBSIDY_IFP_DATA_VALIDATE_URL) || url.includes(APP_CONFIG.SUBSIDY_IFP_DATA_UPLOAD_URL)) {
            return new HttpHeaders({
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'transactionId': this.transactionId,
                'operationType': (url.includes(APP_CONFIG.SUBSIDY_IFP_DATA_UPLOAD_URL) ? 'UPLOAD' : "VALIDATE"),
                'userid': this.userService.getUserName,
            });
        } else if (url.includes(APP_CONFIG.GET_PROFILE_PROVIDER)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'Accept': 'application/json',
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'csAdminId': this.userService.getUserIdentifier,
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'ipAddress': this.userService.getIpAddress,
                'isCSAdminApplication': 'true',
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            })
        }
        else if (url.includes(APP_CONFIG.BROKER_PROFILE_SUBMIT)) {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'Accept': 'application/json',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            })
        }
        else {
            return new HttpHeaders({
                'Content-Type': 'application/json',
                'transactionId': this.transactionId,
                'Accept': 'application/json',
                'source': 'dpadminPortal',
                'loggedInUserId': this.userService.getUserIdentifier || '',
                'loggedInUserName': this.userService.getUserName || '',
                'loggedInUserRole': this.userService.getUserRole || '',
                'x-ibm-client-id': APP_CONFIG.CLIENT_ID || '',
                'x-ibm-client-secret': APP_CONFIG.CLIENT_SECRET || '',
                'sessionId': this.userService.getSessionID,
                'ipAddress': this.userService.getIpAddress,
                'operationType': "AUDIT",
                'userId': this.userService.getUserIdentifier,
                'token': this.userService.getJwtToken,
                'isDpAdminCall': dpAdminCall
            });
        }

    }
}
